// extracted by mini-css-extract-plugin
export default {"mobAppRedirect":"auth__mobAppRedirect__kOVSrS","main":"auth__main__fd33lC","text":"auth__text__trtpXN"};